module.exports = __webpack_public_path__ + "static/media/arrowwhite.c7d71fbb.svg";